<template>
    <div class="modal fade" :id="modal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog" style="max-width:1200px;">
            <div class="modal-content" style="min-height: 500px;">
                <div class="modal-header">
                    <h2>{{titulo}}</h2>
                    <div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal">
                        <span class="svg-icon svg-icon-1">
                            <inline-svg src="media/icons/duotone/Navigation/Close.svg" />
                        </span>
                    </div>
                </div>
                <div class="modal-body scroll-y m-5">
                    <div class="row g-6 g-xl-12">
                        <div class="col-12 col-sm-12" v-if="disciplinas_select">
                            <div class="form-group">
                                <label for="disciplinaId" class="form-check-label">Disciplina:</label>
                                <Multiselect v-model="disciplinaId" :options="disciplinas_select" :searchable="true"></Multiselect>
                            </div>
                        </div>
                        <div class="col-12 col-sm-6">
                            <div class="form-group">
                                <label for="dataAvaliacao" class="form-check-label">Data da Avaliacao:</label>
                                <input required type="date" class="form-control" v-model="dataAvaliacao">
                            </div>
                        </div>
                        <div class="col-12 col-sm-6">
                            <div class="form-group">
                                <label for="dataSolicitacao" class="form-check-label">Data da Solicitacao:</label>
                                <input required type="date" class="form-control" v-model="dataSolicitacao">
                            </div>
                        </div>
                        <!-- <div class="col-12 col-sm-12" v-if="status_select">
                            <div class="form-group">
                                <label for="statusId" class="form-check-label">Status:</label>
                                <Multiselect v-model="statusId" :options="status_select" :searchable="true"></Multiselect>
                            </div>
                        </div> -->
                        <div class="col-12 col-sm-12">
                            <div class="form-group">
                                <label for="justificativa" class="form-check-label">Justificativa:</label>
                                <textarea required rows="4" class="form-control" v-model="justificativa"></textarea>
                            </div>
                        </div>  
                    </div>
                </div>
                <div class="modal-footer">
                    <BotaoSalvar @click="salvar" :processando="processando"></BotaoSalvar>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import SegundaChamadaService from "@/service/v10/sigap/SegundaChamadaService"
import Multiselect from '@vueform/multiselect'
import BotaoSalvar from '@/components/aplicacao/BotaoSalvar.vue';
import { Options, Vue } from "vue-class-component";
import SiteUtils from '@/assets/ts/aplicacao/site';
import $ from "jquery"
import { Prop } from 'vue-property-decorator';

@Options({
    name: "ProfileSegundaChamadaCadastro",
    components: { Multiselect, BotaoSalvar },
    emits: ['segunda-chamada-criada'],
})
export default class ProfileSegundaChamadaCadastro extends Vue {
    
    @Prop() readonly modal!: any
    @Prop() readonly matricula!: any
    @Prop() readonly disciplinas!: any
    @Prop() readonly status!: any

    public service = new SegundaChamadaService();
    public processando = false;
    public titulo = 'Cadastrar Segunda Chamada';

    public disciplinaId: any = null;
    public dataAvaliacao: any = null;
    public dataSolicitacao: any = null;
    public justificativa: any = null; 
    public statusId: any = null;

    get disciplinas_select() {
        if (!this.disciplinas) { return null; }
        return this.disciplinas.map((item) => {
            return { value: item.id, label: item.descricao }
        });
    }

    get status_select() {
        if (!this.status) { return null; }
        return this.status.map((item) => { return { value: item.id, label: item.nome } });
    }

    public getdados() {
        const dados: any = {};
        dados.matriculaId = this.matricula.id;
        dados.disciplinaId = this.disciplinaId;
        dados.dataAvaliacao = this.dataAvaliacao;
        dados.dataSolicitacao = this.dataSolicitacao;
        dados.justificativa = this.justificativa; 
        dados.status = this.statusId;
        return dados;
    }

    public sucesso() {
        this.$emit("segunda-chamada-criada", null);
        this.disciplinaId = null;
        this.dataAvaliacao = null;
        this.dataSolicitacao = null;
        this.justificativa = null; 
        this.statusId = null;
        $("[data-bs-dismiss='modal']").trigger({ type: "click" });
    }

    public salvar() {
        if (this.processando) {
            return;
        }
        if (!this.disciplinaId || !this.dataAvaliacao || !this.dataSolicitacao || !this.justificativa ) {
            SiteUtils.toastErro('Error!', 'Preencha os campos obrigatorios.');
            return;
        }
        this.processando = true;
        const dados = this.getdados();
        setTimeout(() => {
            this.service.cadastrar(dados)
                .then(response => {
                    SiteUtils.toastSucesso('Cadastrado com sucesso!', response.message);
                    this.sucesso();
                    this.processando = false;
                })
                .catch(error => {
                    this.processando = false;
                    SiteUtils.toastErro('Error!', error.data.message);
                });
        }, 100);
    }
}
</script>
